import EmptyState from '../../../components/empty-state'
import Loading from '../../../components/loading'
import Pager from '../../../components/pager'
import { RulesetsState } from '../hooks/use-rulesets'
import RuleSetDisplay from './ruleset-display'

type RulesetsListProps = {
  state: RulesetsState
}

const RulesetsList = (props: RulesetsListProps) => {
  const rulesetsState: RulesetsState = props.state

  return (
    <div className="flex flex-col flex-grow">
      <div className="flex flex-col flex-grow">
        {rulesetsState.loading && <Loading></Loading>}
        {!rulesetsState.loading && (
          <div className="grid grid-cols-1 p-12 pt-6 md:grid-cols-3">
            {rulesetsState.rulesets &&
            rulesetsState.rulesets.length > 0 &&
            rulesetsState.filterByActive !== null
              ? rulesetsState.rulesets
                  .filter((r) => r.isActive === rulesetsState.filterByActive)
                  .map((ruleset) => {
                    return (
                      <div key={`rule-${ruleset.id}`} className="p-4">
                        <RuleSetDisplay ruleset={ruleset}></RuleSetDisplay>
                      </div>
                    )
                  })
              : rulesetsState.rulesets.map((ruleset) => {
                  return (
                    <div key={`rule-${ruleset.id}`} className="p-4">
                      <RuleSetDisplay ruleset={ruleset}></RuleSetDisplay>
                    </div>
                  )
                })}
            {!rulesetsState.loading &&
              (!rulesetsState.rulesets || rulesetsState.rulesets.length <= 0) &&
              !rulesetsState.debouncedQuery &&
              rulesetsState.stateId === -1 && (
                <div className="w-full col-span-3">
                  <EmptyState>No Rulesets Available</EmptyState>
                </div>
              )}
            {!rulesetsState.loading &&
              (!rulesetsState.rulesets || rulesetsState.rulesets.length <= 0) &&
              !rulesetsState.debouncedQuery &&
              rulesetsState.stateId !== -1 && (
                <div className="w-full col-span-3">
                  <EmptyState>
                    No Rulesets Available for
                    <span className="ml-1 font-semibold">
                      {
                        rulesetsState.states.find(
                          (s) => s.id === rulesetsState.stateId
                        )!.name
                      }
                    </span>
                  </EmptyState>
                </div>
              )}
            {!rulesetsState.loading &&
              (!rulesetsState.rulesets || rulesetsState.rulesets.length <= 0) &&
              rulesetsState.debouncedQuery &&
              rulesetsState.stateId === -1 && (
                <div className="w-full col-span-3">
                  <EmptyState>
                    No Rulesets found for
                    <span className="ml-1 font-semibold">
                      {rulesetsState.debouncedQuery}
                    </span>
                  </EmptyState>
                </div>
              )}
            {!rulesetsState.loading &&
              (!rulesetsState.rulesets || rulesetsState.rulesets.length <= 0) &&
              rulesetsState.debouncedQuery &&
              rulesetsState.stateId !== -1 && (
                <div className="w-full col-span-3">
                  <EmptyState>
                    No Rulesets found for
                    <span className="ml-1 mr-1 font-semibold">
                      {rulesetsState.debouncedQuery}
                    </span>
                    in
                    <span className="ml-1 font-semibold">
                      {
                        rulesetsState.states.find(
                          (s) => s.id === rulesetsState.stateId
                        )!.name
                      }
                    </span>
                  </EmptyState>
                </div>
              )}
          </div>
        )}
      </div>
      {!rulesetsState.loading && (
        <Pager
          page={rulesetsState.page}
          pageSize={rulesetsState.pageSize}
          pageOptions={[15, 25, 40]}
          total={rulesetsState.total}
          showArrows
          showDoubleArrows
          onChange={(page, pageSize) => {
            rulesetsState.updatePaging(page, pageSize)
          }}
        />
      )}
    </div>
  )
}

export default RulesetsList
